import { X } from "react-feather";
import styles from "./callDialer.module.css";
import { useState } from "react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

function formatNumber(n) {
  const d = n.replace(/\D/g, "");
  if (d.length <= 3) return d;
  if (d.length <= 6) return d.slice(0, 3) + " " + d.slice(3);
  return d.slice(0, 3) + " " + d.slice(3, 6) + " " + d.slice(6, 10);
}

const CallDialer = (props) => {
  const [num, setNum] = useState("");
  const [hint, setHint] = useState("Enter a number to call");
  const [connecting, setConnecting] = useState(false);

  const pressKey = (k) => {
    setNum((prev) => prev + k);
    setHint("Tap call to connect");
    setConnecting(false);
  };

  const deleteKey = () => {
    setNum((prev) => {
      const next = prev.slice(0, -1);
      if (!next) setHint("Enter a number to call");
      return next;
    });
    setConnecting(false);
  };

  const initiateCall = () => {
    console.log("num", num);

    props.initiateVoiceCallByDialPad(num);
    // setConnecting(true);
    // setHint("Connecting…");
  };

  return (
    <>
      <div
        className={
          props.handleCallDialerClose
            ? `${styles.CallDialerMainSec} ${styles.Active}`
            : `${styles.CallDialerMainSec}`
        }
      >
        <div className={`${styles.DialerHeader}`}>
          <span className={`${styles.DialerHeadTitle}`}>Call dialer</span>
          <div
            className={`${styles.DialerCloseBU}`}
            onClick={() => props.handleCallDialerClose()}
          >
            <X />
          </div>
        </div>

        <div className={`${styles.dialerRoot}`}>
          <div className={`${styles.dialerCard}`}>
            {/* ── Display ── */}
            <div className={`${styles.dialerDisplay}`}>
              <div className={`${styles.dialerNumber}`}>
                {num ? formatNumber(num) : ""}
              </div>
              <div
                className={`${styles.dialerHint} ${
                  connecting ? styles.connecting : ""
                }`}
              >
                {hint}
              </div>
            </div>

            {/* ── Keypad ── */}
            <div className={`${styles.keypad}`}>
              {KEYS.map((k) => (
                <div className={`${styles.keyWrap}`} key={k}>
                  <button
                    className={`${styles.key}`}
                    onClick={() => pressKey(k)}
                  >
                    <span className={`${styles.keyNum}`}>{k}</span>
                  </button>
                </div>
              ))}
            </div>

            {/* ── Bottom row ── */}
            <div className={`${styles.bottomRow}`}>
              {/* left spacer */}
              <div className={`${styles.bottomCol}`} />

              {/* call button */}
              <div className={`${styles.bottomCol}`}>
                <button className={`${styles.callBtn}`} onClick={initiateCall}>
                  <svg viewBox="0 0 24 24">
                    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.27-.27.67-.36 1.02-.22 1.12.41 2.33.63 3.58.63.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.18 21 3 13.82 3 5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.22 1.02L6.6 10.8z" />
                  </svg>
                </button>
              </div>

              {/* backspace */}
              <div className={`${styles.bottomCol} ${styles.bottomColRight}`}>
                {num && (
                  <button className={`${styles.delBtn}`} onClick={deleteKey}>
                    <svg viewBox="0 0 24 24">
                      <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" />
                      <line x1="18" y1="9" x2="12" y2="15" />
                      <line x1="12" y1="9" x2="18" y2="15" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallDialer;
